PJQ.collections.inspections = PJQ.collections.inspections ? PJQ.collections.inspections : {};
PJQ.models.inspections = PJQ.models.inspections ? PJQ.models.inspections : {};
PJQ.views.inspections = PJQ.views.inspections ? PJQ.views.inspections : {};

PJQ.constants.inspections = {
    frequencyTypes: {
        ONCE: 0,
        DAILY: 1,
        WEEKLY: 2,
        BI_WEEKLY: 3,
        MONTHLY: 4
    },
    frequencyNames: {
        0: 'Once',
        1: 'Daily',
        2: 'Weekly',
        3: 'Bi-Weekly',
        4: 'Monthly'
    },
    statuses: {
        OPEN: 0,
        SUBMITTED: 1,
        CLOSED: 2
    },
    statusColors: {
        0: PJQ.constants.colors.GREEN,
        1: PJQ.constants.colors.BLUE,
        2: PJQ.constants.colors.BLACK
    },
    statusNames: {
        0: 'Open',
        1: 'Submitted',
        2: 'Closed'
    },
    responseTypes: {
        CUSTOM: -1,
        PASSFAIL: 0,
        YESNO: 1,
        DATE: 2,
        NUMBER: 3,
        TEXT: 4,
        SIGNATURE: 5
    },
    responseTypeNames: {
        0: 'Pass/Fail',
        1: 'Yes/No',
        2: 'Date',
        3: 'Number',
        4: 'Text',
        5: 'Signature'
    },
    views: {
        INSPECTIONS: 'inspections'
    }
};

PJQ.modules.inspections = {
    routes: [
        {
            route: 'projects/:projectId/inspections',
            name: 'inspections',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "inspections");
            }
        },
        {
            route: 'projects/:projectId/inspections/:inspectionId',
            name: 'inspection',
            callback: function (projectId, inspectionId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "inspections", {
                    inspectionId: parseInt(inspectionId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.inspections.routes);
PJQ.views.inspections.InspectionItemsDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: '<div class="wd-100 d-flex justify-content-start align-content-start"><button type="button" title="Copy Link" class="btn btn-outline-primary btn-add-section"><i class="fal fa-plus mr-1"></i>Add Section</button></div>'
        },
        enableColumnResize: false
    },
    events: {
        'click .btn-bulk-add-items': 'bulkAddItems',
        'click .btn-add-section': 'addSection',
        'click .btn-add-item': 'addItem',
        'click .btn-delete-section': 'deleteSection',
        'click .btn-delete-item': 'deleteItem',
        'click .item-response-group>button': 'responseGroupClicked',
        'click .btn-signature': 'signatureClicked',
        'click .btn-item-attachments': 'manageItemAttachments'
    },
    beforeRender: function () {
        this.options.isHideSearch = true;
        this.options.order = [1, 'asc']
        this.options.canEdit = true;

        let itemCount = 0;
        _.each(this.options.data, (section) => {
            itemCount += section.items?.length ?? 0;
        });
        this.options.expandAll = itemCount < 30;

        // Add a background color to the section rows
        this.options.rowCallback = (row, data, index) => {
            $(row).addClass('section-row');
        };

        let sortableData = [];
        _.each(this.options.data, (section) => {
            sortableData.push(section);
            sortableData = sortableData.concat(section.items.models);
        });

        this.options.sortableOptions = {
            handle: '.sort-handle',
            dataAttribute: 'sortOrder',
            data: sortableData,
            isNestedTable: true
        }
    },
    getColumns: function () {
        return [
            {
                // "data": "",
                "title": '<i class="fal ' + (_.size(this.expandedItems) > 0 || (this.options.expandAll && this.expandedItems == null) ? 'fa-minus-circle' : 'fa-plus-circle') + ' toggle-all-rows" style="cursor: pointer"></i>',
                "orderable": false,
                "width": "60px",
                "render": (data, type, row) => {
                    let html = '';
                    if (this.options.canEdit) {
                        html += '<i class="fas fa-sort sort-handle mr-2"></i>';
                    }

                    html += `<i class="fal fa-plus-circle toggle-row" data-type="" data-id="${row.id}" style="cursor: pointer"></i>`;
                    return `<div class="text-align-center">${html}</div>`;
                }
            },
            {
                "columnData": "attributes.sortOrder",
                "title": "",
                "orderable": false,
                "width": "35px",
                "render": (data, type, row) => {
                    let html = '';
                    html += `<div>${row.get('sortOrder')}</div>`;
                    return `<div class="d-flex justify-content-center align-items-center">${html}</div>`;
                }
            },
            {
                "columnData": "",
                "title": "Title",
                "orderable": false,
                "render": (data, type, row) => {
                    let title = row.get('title') ?? '';
                    if (this.options.canEdit) {
                        return `<input type="text" class="form-control input-title" maxlength="512" value="${title}" data-p-bind="title">`;
                    }

                    return title;
                }
            },
            // {
            //     "columnData": "",
            //     "title": "Details",
            //     "orderable": false,
            //     "width": "20%",
            //     "render": (data, type, row) => {
            //         return '';
            //     }
            // },
            {
                "columnData": "",
                "title": "Response Type",
                "orderable": false,
                "width": "200px",
                "render": (data, type, row) => {
                    return '';
                }
            },
            {
                "columnData": "",
                "title": "Preview",
                "width": "300px",
                "orderable": false,
                "render": (data, type, row) => {
                    return '';
                }
            },
            {
                "title": '',
                "orderable": false,
                "width": "40px",
                "render": (data, type, row) => {
                    let html = '';

                    if (this.options.canEdit) {
                        html += `<button type="button" class="btn btn-danger btn-delete-section ml-1 fs-14"><span class="fal fa-trash"></span></button>`;
                    }
                    return `<div class="text-align-right show-on-row-hover">${html}</div>`;
                }
            }
        ];
    },
    getItemColumns: function () {
        return [
            {
                "title": '',
                "orderable": false,
                "width": "25px",
                "render": () => {
                    if (this.options.canEdit) {
                        return '<div class="sort-handle text-align-center"><i class="fas fa-sort"></i></div>';
                    } else {
                        return '';
                    }
                }
            },
            {
                "columnData": "",
                "title": "",
                "orderable": false,
                "width": "35px",
                "render": (data, type, row) => {
                    let section = this.options.data.find((model) => model.items.get(row.cid) != null);
                    if (type === 'sort') {
                        return row.get('sortOrder');
                    }

                    let html = '';
                    html += `<div>${section?.get('sortOrder') ?? 0}.${row.get('sortOrder')}</div>`;
                    return `<div class="d-flex justify-content-center align-items-center">${html}</div>`;
                }
            },
            {
                "columnData": "",
                "title": "Title",
                "orderable": false,
                "render": (data, type, row) => {
                    let title = row.get('title') ?? '';
                    if (this.options.canEdit) {
                        return `<textarea type="text" class="form-control" rows="2" maxlength="512" data-p-bind="title">${title}</textarea>`;
                    }

                    return title;
                }
            },
            // {
            //     "columnData": "",
            //     "title": "Details",
            //     "orderable": false,
            //     "width": "20%",
            //     "render": (data, type, row) => {
            //         let details = row.get('details') ?? '';
            //         if (this.options.canEdit) {
            //             return `<input type="text" class="form-control" maxlength="256" value="${details}" data-p-bind="details">`;
            //         }
            //
            //         return details;
            //     }
            // },
            {
                "columnData": "",
                "title": "Response Type",
                "orderable": false,
                "width": "200px",
                "render": (data, type, row) => {
                    return `<select class="form-control" data-p-bind="responseType">`;
                }
            },
            {
                "columnData": "",
                "title": "Preview",
                "width": "300px",
                "orderable": false,
                "render": (data, type, row) => {
                    let html = '';
                    switch (row.get('responseType')) {
                        case PJQ.constants.inspections.responseTypes.PASSFAIL:
                            html += `
                                <div class="d-flex">
                                    <div class="btn-group flex-fill item-response-group" data-id="${row.cid}">
                                        <button type="button" data-value="true" class="btn btn-success ${row.get('response') !== true ? 'inactive' : ''}">Pass</button>
                                        <button type="button" data-value="false" class="btn btn-danger ${row.get('response') !== false ? 'inactive' : ''}">Fail</button>
                                        <button type="button" data-value="null" class="btn btn-light ${row.get('response') != null ? 'inactive' : ''}">N/A</button>
                                    </div>
                                </div>
                            `;
                            break;
                        case PJQ.constants.inspections.responseTypes.YESNO:
                            html += `
                                <div class="d-flex">
                                    <div class="btn-group flex-fill item-response-group" data-id="${row.cid}">
                                        <button type="button" data-value="true" class="btn btn-success ${row.get('response') !== true ? 'inactive' : ''}">Yes</button>
                                        <button type="button" data-value="false" class="btn btn-danger ${row.get('response') !== false ? 'inactive' : ''}">No</button>
                                        <button type="button" data-value="null" class="btn btn-light ${row.get('response') != null ? 'inactive' : ''}">N/A</button>
                                    </div>
                                </div>
                            `
                            break;
                        case PJQ.constants.inspections.responseTypes.DATE:
                            html += `<div class="form-group"><div class="input-group wd-160p"><input type="text" class="form-control input-date"/></div></div>`;
                            break;
                        case PJQ.constants.inspections.responseTypes.NUMBER:
                            html += `<input type="text" class="form-control input-decimal wd-120p" value="${row.get('response') ?? ''}" data-p-bind="response" placeholder="0"/>`;
                            break
                        case PJQ.constants.inspections.responseTypes.TEXT:
                            html += `<input type="text" class="form-control input-response-text" value="${row.get('response') ?? ''}" data-p-bind="response"/>`;
                            break;
                        case PJQ.constants.inspections.responseTypes.SIGNATURE:
                            html += `<button type="button" class="btn btn-primary wd-60p btn-signature">Sign</button>`;
                            break;
                        case PJQ.constants.inspections.responseTypes.CUSTOM:
                            let responseType = this.options.responseTypes.get(row.get('responseTypeId'));
                            if (responseType) {
                                html = responseType.getInputHtml();
                            }
                            break;
                    }
                    return html;
                }
            },
            {
                "title": '',
                "orderable": false,
                "width": "40px",
                "render": (data, type, row) => {
                    let html = '';

                    if (this.options.canEdit) {
                        // html += `<button type="button" class="btn btn-link btn-item-attachments ht-35p fs-14 visible"><span class="fal fa-paperclip-vertical mr-1"></span><span class="item-attachments-count">${_.size(row.attachments.models)}</span></button>`
                        html += `<button type="button" class="btn btn-danger btn-delete-item"><span class="fal fa-trash"></span></button>`;
                    }
                    return `<div class="show-on-row-hover text-align-center">${html}</div>`;
                }
            }
        ];
    },
    afterDataTableRender: function () {
        // Hide sorting icons. Can't do bSort = false because we still want to sort by sortOrder
        this.$('thead th').removeClass('sorting sorting_asc sorting_desc');
        this.renderInputs();
    },
    onChildRowToggle: function (row) {
        let $row = $(row.node());
        let $icon = $row.find('.toggle-row');

        if (!$icon.hasClass('fa-plus-circle')) {
            this.renderInputs();
        }
    },
    onNestedRowSorted(item, newSort, newParent) {
        if (newParent) {
            let parent = _.find(this.options.data, (section) => {
                return _.some(section.items.models, {cid: item.cid});
            });

            if (parent == null) {
                return;
            }

            if (parent.cid === newParent.cid) {
                let oldSort = item.get('sortOrder');
                item.set('sortOrder', newSort);

                _.each(parent.items.models, (model) => {
                    if (model.cid !== item.cid) {
                        if (oldSort < newSort) {
                            if (model.get('sortOrder') > oldSort && model.get('sortOrder') <= newSort) {
                                model.set('sortOrder', model.get('sortOrder') - 1);
                            }
                        } else if (oldSort > newSort) {
                            if (model.get('sortOrder') < oldSort && model.get('sortOrder') >= newSort) {
                                model.set('sortOrder', model.get('sortOrder') + 1);
                            }
                        }
                    }
                });
            } else {
                parent.items.remove(item);

                _.each(parent.items.models, (model) => {
                    if (model.get('sortOrder') > item.get('sortOrder')) {
                        model.set('sortOrder', model.get('sortOrder') - 1);
                    }
                });

                newParent.items.add(item);

                item.set('sortOrder', newSort);

                _.each(newParent.items.models, (model) => {
                    if (model.get('sortOrder') >= newSort && model.cid !== item.cid) {
                        model.set('sortOrder', model.get('sortOrder') + 1);
                    }
                });
            }
        } else {
            let oldSort = item.get('sortOrder');

            item.set('sortOrder', newSort);

            _.each(this.options.data, (section) => {
                if (section.cid !== item.cid) {
                    if (oldSort < newSort) {
                        if (section.get('sortOrder') > oldSort && section.get('sortOrder') <= newSort) {
                            section.set('sortOrder', section.get('sortOrder') - 1);
                        }
                    } else if (oldSort > newSort) {
                        if (section.get('sortOrder') < oldSort && section.get('sortOrder') >= newSort) {
                            section.set('sortOrder', section.get('sortOrder') + 1);
                        }
                    }
                }
            });
        }

        this.preserveScrollRender();
    },
    responseGroupClicked: function (e) {
        let $target = $(e.currentTarget),
            $group = $target.closest('.item-response-group'),
            $buttons = $group.find('button'),
            value = $target.data('value'),
            itemId = $group.data('id'),
            item = this.inputCollection.get(itemId);

        if (item) {
            $buttons.removeClass('inactive');
            $buttons.not($target).addClass('inactive');
        }
    },
    signatureClicked: function (e) {
        let $target = $(e.currentTarget),
            itemId = $target.closest('tr').attr('id'),
            item = this.inputCollection.get(itemId);
        if (item) {
            new PJQ.views.signatures.SignatureSubmitModal({
                onSubmit: _.bind(function (signature, callback) {
                    callback();
                }, this)
            });
        }
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

        if (this.sectionBinder) {
            this.sectionBinder.remove();
            this.sectionBinder = null;
        }

        this.sectionBinder = new PJQ.Binder(this.$('.section-row'), this.options.data, {
            delegate: true,
            modelSelectorAttribute: 'id',
            idAttribute: 'cid',
            useDecimalPercentFields: true,
            watchElements: [
                'input'
            ]
        });

        if (!this.inputCollection) {
            this.inputCollection = new PJQ.collections.inspections.Items();
        }

        this.inputCollection.reset();
        _.each(this.options.data, (section) => {
            this.inputCollection.add(section.items.models);
        });

        if (this.itemsBinder) {
            this.itemsBinder.remove();
            this.itemsBinder = null;
        }

        this.itemsBinder = new PJQ.Binder(this.$('.child-row'), this.inputCollection, {
            delegate: true,
            modelSelectorAttribute: 'id',
            idAttribute: 'cid',
            useDecimalPercentFields: true,
            watchElements: ['input', 'textarea'],
            inputs: {
                responseType: {
                    onChange: ($input, attr, value, obj) => {
                        let responseTypeId,
                            responseType;
                        if (value > 0) {
                            responseType = value;
                            responseTypeId = null;
                        } else {
                            responseType = PJQ.constants.inspections.responseTypes.CUSTOM;
                            responseTypeId = -value;
                        }
                        obj.set({
                            responseType: responseType,
                            responseTypeId: responseTypeId
                        });
                    },
                    afterChange: ($el, value, model) => {
                        if (model != null) {
                            this.renderChildColumn(4, model, 1);
                        }
                    },
                    selectPicker: {
                        choices: () => {
                            let types = _.map(_.filter(PJQ.constants.inspections.responseTypes, (responseType) => {
                                return responseType !== PJQ.constants.inspections.responseTypes.CUSTOM;
                            }), function (responseType) {
                                return {
                                    id: responseType,
                                    name: PJQ.constants.inspections.responseTypeNames[responseType]
                                }
                            });

                            types.push(..._.map(this.options.responseTypes?.models, (responseType) => {
                                return {
                                    id: -responseType.id,
                                    name: responseType.get('name')
                                }
                            }));

                            return types;
                        }
                    }
                },
            }
        });

        new PJQ.inputs.DatePickerCollection(this.$el, this.inputCollection.models, {
            pickerSelector: '.input-date',
            datePickerOptions: {
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                },
            }
        });
    },
    getRowChildData: function (row) {
        return _.sortBy(_.filter(row.data().items.models, (item) => !item.get('delete')), function (model) {
            return model.get('sortOrder');
        });
    },
    getRowChildColumns: function (row) {
        return this.getItemColumns();
    },
    getChildFooter: function (row) {
        let sectionId = row.id();
        return `<td colspan="7" class="text-left p-2">
                    <button class="btn btn-sm btn-outline-primary btn-add-section mr-1" data-section-id="${sectionId}">+ Add Section</button>
                    <button class="btn btn-sm btn-outline-primary btn-add-item mr-1" data-section-id="${sectionId}">+ Add Item</button>
                    <button type="button" class="btn btn-sm btn-outline-dark btn-bulk-add-items mr-1" data-section-id="${sectionId}">+ Bulk Add Items</button>
                </td>`;
    },
    addSection: function (e) {
        let currentSortOrder = 0;
        if (e) {
            let $target = $(e.currentTarget),
                sectionId = $target.data('section-id');
            if (this.options.data && this.options.data.length) {
                let currentSection = this.options.data.find((model) => model.cid === sectionId);
                if (currentSection) {
                    currentSortOrder = currentSection.get('sortOrder');
                    _.each(this.options.data, (section) => {
                        if (section.get('sortOrder') > currentSortOrder) {
                            section.set('sortOrder', section.get('sortOrder') + 1);
                        }
                    });
                }
            }
        } else {
            _.each(this.options.data, (section) => {
                let tSort = section.get('sortOrder');
                if (tSort > currentSortOrder) {
                    currentSortOrder = tSort;
                }
            });
        }

        let newSection = new PJQ.models.inspections.Section({
            sortOrder: currentSortOrder + 1
        });
        this.options.data.push(newSection);
        if (typeof this.options.onSectionAdd === 'function') {
            this.options.onSectionAdd(newSection);
        }


        if (this.options.expandedRowIds == null) {
            this.options.expandedRowIds = [];
        }
        this.options.expandedRowIds.push(newSection.cid);
        this.preserveScrollRender();
    },
    preserveScrollRender: function () {
        let modal = $(this.$el.closest('.modal'));
        if (modal.length > 0) {
            let scrollTop = modal.scrollTop();
            this.render();
            modal.scrollTop(scrollTop);
        } else if (this.options.$scrollEl != null) {
            let scrollTop = this.options.$scrollEl.scrollTop();
            this.render();
            this.options.$scrollEl.scrollTop(scrollTop);
        }
    },
    manageItemAttachments(e) {
        let $target = $(e.currentTarget),
            $row = $($target.closest('tr')),
            $count = $target.find('.item-attachments-count'),
            section = _.find(this.options.data, (model) => model.cid === $row.data('parent-id')),
            item = section.items.get($row.attr('id'));

        if (item) {
            new PJQ.views.inspections.InspectionItemAttachmentsModal({
                model: item,
                canEdit: this.options.canEdit,
                onChange: () => {
                    item.set('attachments', item.attachments.toJSON());
                    $count.text(_.size(item.attachments.models));
                }
            });
        }
    },
    addItem: function (e) {
        let $target = $(e.currentTarget),
            sectionId = $target.data('section-id'),
            section = this.options.data.find((model) => model.cid === sectionId);
        if (section) {
            let undeletedItems = _.filter(section.items.models, (model) => !model.get('delete'));
            let newItem = new PJQ.models.inspections.Item({
                sortOrder: _.size(undeletedItems) + 1,
                responseType: this.options.model?.get('defaultResponseTypeId') ?? PJQ.constants.inspections.responseTypes.PASSFAIL
            });

            section.items.add(newItem);
            this.preserveScrollRender();

            if (typeof this.options.onItemAdd === 'function') {
                this.options.onItemAdd(newItem);
            }
        }
    },
    bulkAddItems: function (e) {
        let $target = $(e.currentTarget),
            sectionId = $target.data('section-id'),
            section = this.options.data.find((model) => model.cid === sectionId);
        new PJQ.views.inspections.BulkAddInspectionItemsModal({
            section: section,
            responseType: this.options.model?.get('defaultResponseTypeId') ?? PJQ.constants.inspections.responseTypes.PASSFAIL,
            onSave: () => {
                this.preserveScrollRender();
            }
        });
    },
    deleteSection: function (e) {
        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            section = row.data();
        if (section) {
            section.set('delete', true);

            _.each(this.options.data, (sect) => {
                if (sect.get('sortOrder') > section.get('sortOrder')) {
                    sect.set('sortOrder', sect.get('sortOrder') - 1);
                }
            });

            this.options.data = _.filter(this.options.data, (model) => {
                return !model.get('delete');
            });

            this.preserveScrollRender();

            if (typeof this.options.onSectionDelete === 'function') {
                this.options.onSectionDelete(section);
            }
        }
    },
    deleteItem: function (e) {
        let $target = $(e.currentTarget),
            $row = $($target.closest('tr')),
            section = _.find(this.options.data, (model) => model.cid === $row.data('parent-id')),
            item = section.items.get($row.attr('id'));
        if (item) {
            item.set('delete', true);

            _.each(item.collection.models, (model) => {
                if (model.get('sortOrder') > item.get('sortOrder')) {
                    model.set('sortOrder', model.get('sortOrder') - 1);
                }
            });

            this.preserveScrollRender();

            if (typeof this.options.onItemDelete === 'function') {
                this.options.onItemDelete(item);
            }
        }
    }
});

PJQ.views.inspections.InspectionEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-edit-inspection'),
        subTemplates: {
            section: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspection-section')
        },
        width: '95%',
        maxWidth: 1200,
        model: null,
        isShowCloseButton: true,
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-email': 'email',
        'click .btn-export': 'export',
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete',
        'click .btn-mark-all-na': 'markSectionNotApplicable',
        'click .btn-na': 'markItemNotApplicable',
        'click .inspection-items-header': 'toggleAllSections',
        'click .btn-item-comments': 'viewItemComments',
        'click .btn-item-attachments': 'viewItemAttachments',
        'click .btn-signature': 'editSignature',
        'click .btn-submit': 'submit'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ?? PJQ.app.session.project;
        this.preferences = this.options.project.preferences;

        if (this.model == null) {
            let template = this.options.inspectionTemplate;
            this.model = new PJQ.models.inspections.Inspection({
                projectId: this.options.project.id,
                templateId: template.id,
                name: template.get('name'),
                description: template.get('description'),
                typeId: template.get('typeId'),
                groupId: template.get('groupId'),
                attachments: template.get('attachments'),
                inspectionDate: new Date(),
                statusId: PJQ.constants.inspections.statuses.OPEN
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.inspectionTypes = await this.options.project.fetchInspectionTypes();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;

        this.options.isAdmin = this.options.project.hasPermission('inspections.isAdmin');
        this.options.canEdit = (this.options.isAdmin || this.model.isNew() || this.model.get('canEdit')) && this.model.get('statusId') !== PJQ.constants.inspections.statuses.CLOSED && this.model.get('statusId') !== PJQ.constants.inspections.statuses.SUBMITTED;
    },
    renderData: function () {
        return {
            model: this.model,
            preferences: this.preferences,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            items: _.union(..._.map(this.model.sections.models, (section) => section.items.models))
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        let self = this;
        this.binder = new PJQ.Binder(this.$el, this.model, {
            project: this.options.project,
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: this.options.canEdit,
            setDefaultValues: true,
            inputs: {
                attachments: {
                    fileUploader: {
                        useApiV2: true,
                        canView: false,
                    }
                },
                typeId: {
                    selectPicker: {
                        canEdit: this.options.isAdmin && _.find(this.inspectionTypes.models, (type) => { return type.id === this.model.get('typeId') }) == null,
                        choices: _.map(this.inspectionTypes.models, (type) => {
                            return {
                                id: type.id,
                                name: type.get('name')
                            };
                        })
                    }
                },
                statusId: {
                    selectPicker: {
                        canEdit: this.options.isAdmin,
                        choices: _.map(PJQ.constants.inspections.statuses, (status) => {
                            return {
                                id: status,
                                name: PJQ.constants.inspections.statusNames[status]
                            };
                        })
                    }
                },
                dueDate: {
                    datePicker: {
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: this.model.get('dueDate') ?? null
                        }
                    }
                },
                inspectionDate: {
                    datePicker: {
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: this.model.get('inspectionDate') ?? null
                        }
                    }
                },
                groupId: {
                    groupPicker: {}
                },
                locationId: {
                    locationPicker: {}
                },
                assignedTo: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: false,
                        canEdit: this.options.canEdit && this.options.isAdmin
                    }
                },
                distributeTo: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: false,
                        canEdit: this.options.canEdit && this.options.isAdmin
                    }
                },
                pointOfContact: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: true,
                        canEdit: this.options.canEdit && this.options.isAdmin
                    }
                }
            }
        });

        this.$el.off('show.bs.collapse hide.bs.collapse', '.section-collapse').on('show.bs.collapse', '.section-collapse', function (e) {
            e.stopPropagation();
            let $caret = $(this).prev().find('.section-caret i');
            $caret.removeClass('fa-caret-right').addClass('fa-caret-down');
            let $otherSections = self.$('.section-collapse').not(this);
            let anyExpanded = $otherSections.filter('.show').length > 0 || true;
            let $itemsCaret = self.$('.items-caret');
            if (anyExpanded) {
                $itemsCaret.removeClass('fa-caret-right').addClass('fa-caret-down');
            }
        }).on('hide.bs.collapse', '.section-collapse', function (e) {
            e.stopPropagation();
            let $caret = $(this).prev().find('.section-caret i');
            $caret.removeClass('fa-caret-down').addClass('fa-caret-right');
            let $otherSections = self.$('.section-collapse').not(this);
            let anyExpanded = $otherSections.filter('.show').length > 0;
            let $itemsCaret = self.$('.items-caret');
            if (!anyExpanded) {
                $itemsCaret.removeClass('fa-caret-down').addClass('fa-caret-right');
            }
        });

        this.renderSections();
    },
    renderSections: function () {
        this.$('.inspection-items').empty();

        _.each(_.sortBy(this.model.sections.models, (model) => {
            return model.get('sortOrder')
        }), (section) => {
            this.renderSection(section);
        });

        this.updateSectionCounts();
    },
    renderSection: function (section, replace = false) {
        if (section.items.length === 0) {
            return true;
        }

        let $container = this.$('.inspection-items');
        if (replace) {
            $container = this.$('.section-outer[data-cid="' + section.cid + '"]');
        }

        this.renderSubTemplate(true, this.options.subTemplates.section, $container, {
            section: section,
            items: _.sortBy(section.items.models, (model) => {
                return model.get('sortOrder')
            }),
            canEdit: this.options.canEdit,
            responseTypes: this.model.responseTypes
        }, {
            replace: replace,
            callback: ($section) => {
                PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

                section.progressBar = new PJQ.progress.ProgressBar($section.find('.section-progress'), {
                    isShowPercentage: false,
                    height: 10,
                    progress: 0,
                    borderRadius: '.1rem'
                });


                new PJQ.Binder($section, section.items, {
                    watchElements: [
                        'input'
                    ],
                    setDefaultValues: true,
                    delegate: true,
                    modelSelectorAttribute: 'data-cid',
                    modelSelector: '.item-input',
                    canEdit: this.options.canEdit,
                    inputs: {
                        responseDate: {
                            datePicker: {
                                datepickerOptions: {
                                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                                    defaultValue: (item) => {
                                        return item.get('response');
                                    },
                                }
                            },
                            onChange: ($input, attr, value, item) => {
                                item.set('response', value);
                            },
                        },
                        choiceId: {
                            buttonGroup: {
                                fitWidth: true,
                                buttons: (item) => {
                                    if (item.get('responseType') === PJQ.constants.inspections.responseTypes.CUSTOM) {
                                        let responseType = this.model.responseTypes.get(item.get('responseTypeId'));
                                        if (responseType == null) {
                                            return [];
                                        }
                                        return _.map(responseType.choices.models, (choice) => {
                                            let color = 'light';
                                            if (choice.get('value') === true) {
                                                color = 'success';
                                            } else if (choice.get('value') === false) {
                                                color = 'danger';
                                            }
                                            return {
                                                label: choice.get('name'),
                                                value: choice.id,
                                                colorClass: color
                                            }
                                        });
                                    } else if (item.get('responseType') === PJQ.constants.inspections.responseTypes.YESNO) {
                                        return [
                                            {
                                                label: "Yes",
                                                value: 0,
                                                colorClass: "success"
                                            },
                                            {
                                                label: "No",
                                                value: -2,
                                                colorClass: "danger"
                                            },
                                            {
                                                label: "N/A",
                                                value: -1,
                                                colorClass: "light"
                                            }
                                        ];
                                    } else if (item.get('responseType') === PJQ.constants.inspections.responseTypes.PASSFAIL) {
                                        return [
                                            {
                                                label: "Pass",
                                                value: 0,
                                                colorClass: "success"
                                            },
                                            {
                                                label: "Fail",
                                                value: -2,
                                                colorClass: "danger"
                                            },
                                            {
                                                label: "N/A",
                                                value: -1,
                                                colorClass: "light"
                                            }
                                        ];
                                    }
                                }
                            }
                        }
                    },
                    afterChange: () => {
                        this.updateSectionCounts();
                    }
                });
            }
        });
    },
    editSignature: function (e) {
        let $target = $(e.currentTarget),
            itemId = $target.closest('.item-container').data('cid'),
            item = this.model.sections.find((section) => section.items.find((model) => model.cid === itemId)).items.find((model) => model.cid === itemId);

        if (item) {
            new PJQ.views.signatures.SignatureSubmitModal({
                fetchSignature: false,
                signature: item.get('response'),
                onSubmit: _.bind(function (signature, callback) {
                    item.set('response', signature);
                    $target.text('Signed');
                    this.updateSectionCounts();
                    callback();
                }, this)
            });
        }
    },
    toggleAllSections: function () {
        let $allSections = this.$('.section-collapse'),
            allExpanded = $allSections.filter('.show').length === $allSections.length;
        if (allExpanded) {
            $allSections.collapse('hide');
            this.$('.items-caret').removeClass('fa-caret-down').addClass('fa-caret-right');
        } else {
            $allSections.collapse('show');
            this.$('.items-caret').removeClass('fa-caret-right').addClass('fa-caret-down');
        }
    },
    toggleSection: function (section, hide) {
        if (section == null || section.cid == null) {
            return;
        }

        let $section = this.$(`.section-collapse[data-cid="${section.cid}"]`);
        if (hide) {
            $section.collapse('hide');
            this.$('.items-caret').removeClass('fa-caret-down').addClass('fa-caret-right');
        } else {
            $section.collapse('show');
            this.$('.items-caret').removeClass('fa-caret-right').addClass('fa-caret-down');
        }
    },
    updateSectionCounts: function () {
        let $sections = this.$('.section-dropdown');
        $sections.each((index, el) => {
            let cid = $(el).data('cid'),
                section = this.model.sections.get(cid);
            if (section) {
                let passCount = 0,
                    failCount = 0,
                    naCount = 0;
                _.each(section.items.models, (item) => {
                    if (item.isNA(this.model.responseTypes)) {
                        naCount++;
                        return true;
                    }

                    if (item.get('responseTypeId') > 0) {
                        let responseType = this.model.responseTypes.get(item.get('responseTypeId')),
                            choiceId = item.get('choiceId'),
                            choice = responseType.choices.get(choiceId);
                        if (choice == null) {
                            return true;
                        } else if (choice.get('value') === false) {
                            failCount++;
                        } else if (choice.get('value') === true) {
                            passCount++;
                        }
                    } else {
                        if ((item.get('choiceId') === 0 || (item.get('choiceId') == null) && item.getResponseSize() > 0)) {
                            passCount++;
                        } else if (item.get('choiceId') === -2) {
                            failCount++;
                        }
                    }
                });

                $(el).find('.pass-count').text(passCount);
                $(el).find('.fail-count').text(failCount);
                $(el).find('.na-count').text(naCount);
                let completeItemsCount = passCount + failCount + naCount,
                    $itemCountsSpan = $(el).find('.item-counts');

                $itemCountsSpan.text(`${completeItemsCount}/${_.size(section.items.models)}`);

                if (section.progressBar != null) {
                    let progressPercent = Math.round((completeItemsCount / _.size(section.items.models)) * 100);
                    section.progressBar.updateProgress(progressPercent, PJQ.views.prequal.PrequalEditor.prototype.getCompletionColorClass(progressPercent));
                }
            }
        });
    },
    viewItemComments: function (e) {
        let $target = $(e.currentTarget),
            $item = $target.closest('.item-container'),
            $commentsCount = $item.find('.comments-count'),
            itemId = $item.data('cid'),
            item = this.model.sections.find((section) => section.items.find((model) => model.cid === itemId)).items.find((model) => model.cid === itemId);

        if (item != null) {
            new PJQ.views.inspections.CommentsModal({
                model: item,
                section: this.model.sections.find((section) => section.id === item.get('sectionId')),
                canEdit: this.options.canEdit,
                onClose: () => {
                    let count = _.size(_.filter(item.comments.models, (comment) => !comment.get('delete')));
                    $commentsCount.text(count);
                }
            });
        }
    },
    viewItemAttachments: function (e) {
        let $target = $(e.currentTarget),
            $item = $target.closest('.item-container'),
            $attachmentsCount = $item.find('.attachments-count'),
            itemId = $item.data('cid'),
            item = this.model.sections.find((section) => section.items.find((model) => model.cid === itemId)).items.find((model) => model.cid === itemId);
        if (item != null) {
            new PJQ.views.inspections.InspectionItemAttachmentsModal({
                model: item,
                section: this.model.sections.find((section) => section.id === item.get('sectionId')),
                canEdit: this.options.canEdit,
                project: this.options.project,
                onChange: () => {
                    let count = _.size(_.filter(item.attachments.models, (attachment) => !attachment.get('delete')));
                    $attachmentsCount.text(count);

                    item.set('attachments', item.attachments.toJSON());
                }
            });
        }
    },
    markSectionNotApplicable: function (e) {
        e.stopPropagation();

        let $target = $(e.currentTarget),
            $section = $target.closest('.section-dropdown'),
            cid = $section.data('cid'),
            section = this.model.sections.get(cid);
        if (section) {
            _.each(section.items.models, (item) => {
                let rTypeId = item.get('responseTypeId');
                if (rTypeId > 0) {
                    let responseType = this.model.responseTypes.get(rTypeId),
                        naChoice = _.find(responseType.choices.models, (choice) => {
                            return choice.get('value') == null;
                        });
                    if (naChoice != null) {
                        item.set('choiceId', naChoice.id);
                    }
                } else {
                    item.set('choiceId', -1);
                }
            });

            this.renderSection(section, true);
            this.updateSectionCounts();
        }
    },
    markItemNotApplicable: function (e) {
        let $target = $(e.currentTarget),
            $item = $target.closest('.item-container'),
            itemId = $item.data('cid'),
            item = this.model.sections.find((section) => section.items.find((model) => model.cid === itemId)).items.find((model) => model.cid === itemId);
        if (item.get('choiceId') === -1) {
            item.set('choiceId', null);
            $target.addClass('inactive');
        } else if (item.get('choiceId') == null) {
            item.set('choiceId', -1);
            $target.removeClass('inactive');
        }
        this.updateSectionCounts();
    },
    email: function () {
        let inspectionName = this.model.get('name'),
            subject = `Inspection Shared${_.size(inspectionName) > 0 ? ` - ${inspectionName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: "Email Inspection",
            enableCC: false,
            subject: subject,
            onSaveWait: (data, cb) => {
                this.model.share(data, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Inspection email sent'
                    });

                    cb();
                });
            }
        });
    },
    export: function () {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.get('projectId')
                },
                {
                    endpoint: 'inspections',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save((success) => {
                if (success) {
                    callback();
                }
            });
        } else {
            callback();
        }
    },
    validate: function () {
        if (this.errorAlert != null) {
            this.errorAlert.remove();
        }

        let binderRes = this.binder.validate(),
            isValid = binderRes.isValid,
            errors = binderRes.errors;

        if (_.size(errors) > 0) {
            this.errorAlert = new PJQ.Alert(this.$('.error-outer'), {
                type: 'danger',
                text: errors.join('<br>')
            });
        }

        return isValid;
    },
    submit: function() {
        if (!this.validate() || this.model.isNew())
            return;

        this.model.submit((success, err ) => {
            if(success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Inspection submitted successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.removeModal();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while submitting this inspection. Please contact customer service."
                });
            }
        });
    },
    save: function () {
        if (!this.validate())
            return;

        let isNew = this.model.isNew();
        this.model.save(null, {
            success: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                if (isNew) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Inspection created successfully'
                    });

                    this.render();

                    return;
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Inspection saved successfully'
                });
                this.removeModal();
            }
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Inspection?",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        PJQ.notifications.notify.successNotify({
                            message: 'Inspection deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(this.model);
                        }

                        this.removeModal();
                    }
                });
            }
        });
    },
    close: function () {
        let hasChanged = this.model.hasChanged() ||
            this.model.sections.some(section => section.items.some(item => item.hasChanged()));

        if (hasChanged) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: () => {
                    this.save();
                    this.removeModal();
                },
                onDontSave: () => {
                    this.model.sections.forEach(section => {
                        section.items.forEach(item => {
                            if (item.hasChanged()) {
                                item.restore();
                            }
                        });
                    });
                    this.model.restore();
                    this.removeModal();
                }
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.inspections.InspectionItemAttachmentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-inspection-item-attachments'),
        width: '95%',
        maxWidth: 600,
        model: null,
        onClose: null,
        isShowCloseButton: true
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            model: this.model,
            section: this.options.section,
            canEdit: this.options.canEdit
        }
    },
    afterRender: function () {
        let self = this;
        this.binder = new PJQ.Binder(this.$el, this.model, {
            project: this.options.project,
            watchElements: [
                'input',
                'textarea'
            ],
            setDefaultValues: true,
            inputs: {
                attachments: {
                    fileUploader: {
                        useApiV2: true,
                        canView: false,
                        onSuccess: () => {
                            if (typeof this.options.onChange === 'function') {
                                this.options.onChange();
                            }
                        },
                        onDelete: () => {
                            if (typeof this.options.onChange === 'function') {
                                this.options.onChange();
                            }
                        }
                    }
                }
            }
        });
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.inspections.CommentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-inspection-item-comments'),
        maxWidth: 600,
        model: null,
        onClose: null,
        isShowCloseButton: true
    },
    events: {
        'click .btn-add-comment': 'addComment',
        'keyup .comment-text': 'commentChanged',
        'click .btn-close': 'close',
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            model: this.model,
            section: this.options.section,
            comments: this.model.comments?.models ?? [],
            canEdit: this.options.canEdit
        }
    },
    afterRender: function () {
        this.$commentText = this.$('.comment-text');
        this.$addCommentBtn = this.$('.btn-add-comment');

        let $comments = this.$('.comments-outer');
        $comments.scrollTop($comments[0].scrollHeight);
    },
    commentChanged: function () {
        this.commentText = this.$commentText.val();
        this.$addCommentBtn.prop('disabled', this.commentText.length === 0);
    },
    addComment: function () {
        let isValid = this.commentText.length > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$commentText, isValid);

        if (!isValid) {
            return;
        }

        let loader = new PJQ.Loader(this.$addCommentBtn),
            comment = this.model.comments.add({
                createdBy: PJQ.app.session.user ?? PJQ.app.session.contact,
                inspectionId: this.model.get('inspectionId'),
                itemId: this.model.id,
                comment: this.commentText
            });
        comment.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Comment added successfully'
                });
                this.render();
            },
            error: () => {
                comment.destroy();
                loader.remove();
            }
        })
    },
    close: function () {
        this.removeModal();
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
    }
});
PJQ.views.inspections.InspectionsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspections-list'),
        inspectionId: null
    },
    events: {
        'click .btn-view-inspection': 'viewInspectionClicked',
        'click .btn-grp-add-inspection': 'addInspectionButtonGroupClicked',
        'click .btn-add-inspection': 'addInspectionClicked',
        'click .btn-delete-inspection': 'deleteInspectionClicked',
        'click .btn-export': 'export',
        'click .btn-inspection-schedules': 'viewInspectionSchedules',
        'click .btn-inspection-settings': 'viewSettings'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;

        if (this.collection == null) {
            this.collection = new PJQ.collections.inspections.Inspections(null, {
                projectId: this.options.project?.id
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.inspectionTypes = await this.options.project.fetchInspectionTypes();
        this.usedInspectionTypes = _.filter(this.inspectionTypes.models, (type) => {
            return _.contains(this.collection.pluck('typeId'), type.id);
        });

        this.userSettings = await PJQ.app.session.fetchInspectionUserSettings();

        this.locations = await this.options.project.fetchLocations();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.permissions.hasPermission('inspections.canAdd');
        this.options.canEdit = this.options.project.permissions.hasPermission('inspections.canEdit');
        this.options.isAdmin = this.options.project.permissions.hasPermission('inspections.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            project: this.options.project,
            preferences: this.preferences,
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderDataTable();

        this.renderTemplateButtons();

        if (this.options.inspectionId > 0) {
            let initInspection = this.collection.get(this.options.inspectionId);
            if (initInspection != null) {
                this.viewInspection(initInspection);
                this.options.inspectionId = null;
            }
        }
    },
    renderDataTable() {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = null;

        // todo: userSettings
        let self = this;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.inspections-outer'),
            rowId: "cid",
            data: this.collection.models,
            language: {
                emptyTable: 'Click "New Inspection" to create a new Inspections',
                zeroRecords: "No items matched the search criteria"
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'data-table-header-inspections')
            },
            pageLength: this.userSettings?.getSettings(PJQ.constants.inspections.views.INSPECTIONS).rowsPerPage ?? 50,
            orderCookie: PJQ.constants.cookies.INSPECTIONS_ORDER_COOKIE,
            groupByKey: PJQ.constants.cookies.INSPECTIONS_GROUP_BY_KEY,
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.inspections.views.INSPECTIONS),
            headerData: () => {
                return {
                    project: self.options.project,
                    preferences: self.preferences,
                    usedInspectionTypes: this.usedInspectionTypes
                };
            },
            groupBy: this.options.groupBy ?? null,
            getGroupHeader: (group) => {
                return `<div class="p-2 font-weight-bold fs-16">${group}</div>`;
            },
            afterHeaderRender: (view, $header) => {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.inspections-group-by'),
                    defaultValue: view.options.groupBy,
                    onChange: (value) => {
                        this.dataTable.setGroupBy(value);
                    },
                    noneSelectedText: 'None'
                });

                new PJQ.inputs.Selectpicker({
                    el: $header.find('.inspections-filter'),
                    onChange: function (value) {
                        view.setFilter('primary', value);
                    },
                    isGrouped: true,
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });
            },
            getFilterData: function (view, data) {
                let result = data,
                    primaryFilter = view.getFilter('primary'),
                    locationFilter = view.getFilter('location');
                if (_.size(primaryFilter) === 0 && _.size(locationFilter) === 0) {
                    return result;
                }

                let statusFilter = primaryFilter?.statusId ?? [],
                    typeFilter = primaryFilter?.typeId ?? [];
                return _.filter(result, function (row) {
                    return (_.size(typeFilter) === 0 || _.contains(typeFilter, row.get('typeId')))
                        && (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')))
                        && (_.size(locationFilter) === 0 || _.contains(locationFilter, row.get('locationId')));
                });
            },
            deferRender: true,
            onRowDoubleClick: (row) => {
                this.viewInspection(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.viewInspection(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: () => {
                            return this.options.isAdmin;
                        },
                        onClick: (row) => {
                            this.deleteInspection(row.data());
                        }
                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                if (this.userSettings != null) {
                    this.userSettings.save();
                }
            }
        });
    },
    getColumns(includeAllColumns = false) {
        let columns = [], includeColumns = [],
            viewSettings = this.userSettings?.getSettings(PJQ.constants.inspections.views.INSPECTIONS);
        if (includeAllColumns || viewSettings == null) {
            includeColumns = ["name", "type", "assignedTo", "location", "inspectionDate", "dueDate", "progress", "status"];

            if (_.size(this.options.customFields) > 0) {
                _.each(this.options.customFields.models, function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                });
            }
        } else {
            includeColumns = viewSettings.columns;
        }

        _.each(includeColumns, (column) => {
                switch (column) {
                    case "name":
                        columns.push({
                            columnData: "name",
                            data: "attributes.name",
                            title: "Name",
                            width: "200px",
                            group: (row) => {
                                return row.get('name');
                            },
                            render: (data, type, row) => {
                                if (type === 'sort') {
                                    return data;
                                }

                                return `<a href="javascript:void(0);" class="text-primary btn-view-inspection">${data}</a>`;
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "status":
                        columns.push({
                            columnData: "status",
                            data: "attributes.statusId",
                            title: "Status",
                            width: "100px",
                            render: (data, type, row) => {
                                let status = PJQ.constants.inspections.statusNames[data];
                                if (status == null) {
                                    return '';
                                }

                                let statusColor = PJQ.constants.inspections.statusColors[data];
                                return `<span style="color: ${statusColor}">${status}</span>`;
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "type":
                        columns.push({
                            columnData: "type",
                            data: "attributes.typeId",
                            title: "Type",
                            render: (data, type, row) => {
                                if (data == null || !(data > 0)) {
                                    return "";
                                }

                                let inspectionType = this.inspectionTypes.get(data);
                                return inspectionType?.get('name') ?? '';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "group":
                        columns.push({
                            columnData: "groupId",
                            data: "attributes.groupId",
                            title: "Trade",
                            render: function (data, type, row) {
                                return row.get('group')?.name ?? "";
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case 'location':
                        columns.push({
                            columnData: 'location',
                            data: "attributes.locationId",
                            title: "Location",
                            render: (data, type, row) => {
                                let location = this.locations?.get(data);
                                if (location == null) {
                                    return '';
                                }
                                return this.locations?.getFullName(location) ?? "";
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "inspectionDate":
                        columns.push({
                            columnData: "inspectionDate",
                            "data": "attributes.inspectionDate",
                            "title": "Inspection Date",
                            "searchable": false,
                            "width": "80px",
                            "render": function (data, type, row) {
                                if (data == null) {
                                    return '';
                                }

                                let date = _.size(data) > 0 ? new Date(data) : null;
                                if (type === 'sort' || type === 'type') {
                                    return date.valueOf();
                                }

                                return date != null ? PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, true) : null;
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "dueDate":
                        columns.push({
                            columnData: "dueDate",
                            "data": "attributes.dueDate",
                            "title": "Due Date",
                            "searchable": false,
                            "width": "80px",
                            "render": function (data, type, row) {
                                if (data == null) {
                                    return '';
                                }

                                let date = _.size(data) > 0 ? new Date(data) : null;
                                if (type === 'sort' || type === 'type') {
                                    return date.valueOf();
                                }

                                let dateString = PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                if (row.get('statusId') !== PJQ.constants.inspections.statuses.CLOSED && PJQ.helpers.dateHelpers.getDateDaysDiff(date, new Date(), false, true) < 0) {
                                    return '<span class="text-danger font-weight-bold">' + dateString + '</span>';
                                }
                                return dateString;
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "assignedTo":
                        columns.push({
                            columnData: "assignedTo",
                            title: "Assigned To",
                            render: function (data, type, row) {
                                if (_.size(row.assignedTo.models) == null) {
                                    return '';
                                }

                                let result = [];
                                _.each(row.assignedTo.models, function (assignee) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: assignee}));
                                });
                                return result.join(', ');
                            },
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "progress":
                        columns.push({
                            columnData: "progress",
                            title: "Progress",
                            "orderable": false,
                            "searchable": false,
                            render: function (data, type, row) {
                                let stats = row.getStats(),
                                    progress = new PJQ.progress.ProgressBar(null, {
                                        isShowPercentage: false,
                                        height: 10,
                                        progress: (stats.completeItems / stats.totalItems) * 100,
                                        borderRadius: '.1rem'
                                    });

                                let allComplete = stats.totalItems > 0 && stats.totalItems === stats.completeItems;
                                return `<div class="d-flex align-items-center"><div class="flex-fill">${progress.makeProgressBar().outerHTML()}</div><div class="wd-75p ml-3 ${allComplete ? 'font-weight-light' : 'font-weight-bold'}">${stats.completeItems}/${stats.totalItems}</div></div>`;
                            },
                            width: "225px",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                }
            }
        );

        if (!includeAllColumns) {
            columns.push({
                columnData: "inspectionId",
                data: "attributes.inspectionId",
                title: "",
                width: '100px',
                orderable: false,
                searchable: false,
                resizable: false,
                className: 'text-align-center',
                render: (data, type, row) => {
                    let html = '<div class="show-on-row-hover" style="min-width:80px;"><button type="button" data-inspection-id="' + row.id + '" class="btn btn-info btn-view-inspection"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" data-inspection-id="' + row.id + '" class="btn btn-danger btn-delete-inspection ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }
            });
        }

        return columns;
    },
    export: function () {
        if (this.options.project == null) {
            return;
        }

        let filters = {},
            primaryFilter = this.dataTable.getFilter('primary');
        if (_.size(primaryFilter) > 0) {
            if (_.size(primaryFilter.status) > 0) {
                filters.statuses = primaryFilter.status;
            }
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.INSPECTIONS_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
                type: PJQ.constants.reports.reportTypes.INSPECTION.type,
                projectId: this.options.project ? this.options.project.id : null,
                options: {
                    filters: filters,
                    columns: this.userSettings?.getSettings(PJQ.constants.inspections.views.INSPECTIONS).columns,
                    // columnOrder: order
                }
            });
        report.export({format: 'excel'}).then(() => {

        });
    },
    viewSettings: function (e) {
        new PJQ.views.inspections.SettingsModal({
            view: this,
            onSave: () => {
                this.renderDataTable();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }
        });
    },
    viewInspectionClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewInspection(row.data());
    },
    viewInspection: function (item, template) {
        new PJQ.views.inspections.InspectionEditModal({
            model: item,
            inspectionTemplate: template,
            collection: this.collection,
            project: this.options.project,
            onSave: (item) => {
                if (this.collection.get(item.id) == null) {
                    this.dataTable.addRow(item);
                    this.collection.add(item);
                } else {
                    this.dataTable.refresh();
                }
            },
            onDelete: (item) => {
                if (item.id > 0) {
                    let row = this.dataTable.getRow(item.cid);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }
        });
    },
    renderTemplateButtons: function () {
        if (this.templates == null) {
            return;
        }

        let btns = '';
        if (_.size(this.templates.models) === 0) {
            btns += `<a class="dropdown-item disabled" href="javascript:void(0)">No Templates Available</a>`;
        } else {
            _.each(_.groupBy(this.templates.models, (template) => {
                return template.get('typeId');
            }), (templates, typeId) => {
                let type = this.inspectionTypes.get(typeId);
                if (type == null) {
                    return;
                }

                btns += `<h6 class="dropdown-header">${type.get('name')}</h6>`;

                _.each(templates, function (template) {
                    btns += `<a class="dropdown-item btn-add-inspection" data-template-id="${template.id}" href="javascript:void(0)">${template.get('name')}</a>`;
                });
            })
        }

        this.$('.btn-grp-add-inspection>.dropdown-menu').html(btns);
    },
    addInspectionButtonGroupClicked: function () {
        if (this.templates == null) {
            this.options.project.fetchInspectionTemplates().then((templates) => {
                this.templates = templates;
                this.renderTemplateButtons();
            });
        }
    },
    addInspectionClicked: function (e) {
        let templateId = $(e.currentTarget).data('template-id'),
            template = this.templates.get(templateId);
        this.viewInspection(null, template);
    },
    deleteInspectionClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteInspection(row.data());
    },
    deleteInspection: function (inspection) {
        let row = this.dataTable.getRow(inspection.cid);
        if (row == null) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: "Delete Inspection",
            body: "Are you sure you want to delete this Inspection?",
            onDelete: () => {
                inspection.destroy({
                    success: () => {
                        this.dataTable.removeRow(row);
                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(inspection);
                        }
                    }
                });
            }
        });
    },
    viewInspectionSchedules: function () {
        new PJQ.views.inspections.ManageSchedulesModal({
            project: this.options.project,
            onClose: (hadChange) => {
                if (hadChange) {
                    this.collection.fetch({
                        success: () => {
                            this.dataTable.refresh();
                        }
                    })
                }
            }
        });
    }
});
//Models
PJQ.models.inspections.Schedule = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'inspections'
            },
            {
                endpoint: 'schedules',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.frequency == null) {
            model.frequency = PJQ.constants.inspections.frequencyTypes.ONCE;
        }

        if (model.pointOfContact != null) {
            this.pointOfContact = new PJQ.models.contacts.Contact(model.pointOfContact);
        }

        if (_.size(model.assignedTo) > 0 || !this.assignedTo) {
            this.assignedTo = new PJQ.collections.projectContacts.ProjectContacts(model.assignedTo ?? []);
        }

        if (_.size(model.distributeTo) > 0 || !this.distributeTo) {
            this.distributeTo = new PJQ.collections.projectContacts.ProjectContacts(model.distributeTo ?? []);
        }

        this.attachments = new PJQ.collections.inspections.ScheduleAttachments(model.attachments ?? [], {
            isAPIv2: true
        });

        return model;
    },
    beforeSave: function () {
        this.set({
            assignedTo: this.assignedTo.toJSON(),
            assignedToIds: _.pluck(this.assignedTo.models, 'id'),
            distributeTo: this.distributeTo.toJSON(),
            distributeToIds: _.pluck(this.distributeTo.models, 'id'),
            pointOfContact: this.pointOfContact?.toJSON(),
            pointOfContactId: this.pointOfContact?.id,
            attachments: this.attachments.toJSON()
        });
    }
});

// Template Model
PJQ.models.inspections.Template = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.options.project) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
                endpoint: 'inspections'
            },
            {
                endpoint: 'templates',
                value: this.id
            });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.sections = new PJQ.collections.inspections.Sections(model.sections);
        this.attachments = new PJQ.collections.files.Files(model.attachments, {
            isAPIv2: true
        });

        return model;
    },
    beforeSave: function () {
        _.each(this.sections.models, (section) => {
            section.set({
                items: section.items.toJSON()
            });
        });

        this.set({
            attachments: this.attachments.toJSON(),
            sections: this.sections.toJSON()
        });
    }
});

// Inspection Model
PJQ.models.inspections.Inspection = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.get('projectId') && this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'inspections',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.pointOfContact != null) {
            this.pointOfContact = new PJQ.models.contacts.Contact(model.pointOfContact);
        }

        if (_.size(model.assignedTo) > 0 || !this.assignedTo) {
            this.assignedTo = new PJQ.collections.projectContacts.ProjectContacts(model.assignedTo ?? []);
        }

        if (_.size(model.distributeTo) > 0 || !this.distributeTo) {
            this.distributeTo = new PJQ.collections.projectContacts.ProjectContacts(model.distributeTo ?? []);
        }

        this.responseTypes = new PJQ.collections.inspections.ResponseTypes(model.responseTypes);

        this.sections = new PJQ.collections.inspections.Sections(model.sections);
        this.attachments = new PJQ.collections.inspections.Attachments(model.attachments);

        return model;
    },
    beforeSave: function () {
        _.each(this.sections.models, (section) => {
            section.set({
                items: section.items.toJSON()
            });
        });
        this.set({
            assignedTo: this.assignedTo.toJSON(),
            assignedToIds: _.pluck(this.assignedTo.models, 'id'),
            distributeTo: this.distributeTo.toJSON(),
            distributeToIds: _.pluck(this.distributeTo.models, 'id'),
            pointOfContact: this.pointOfContact?.toJSON(),
            pointOfContactId: this.pointOfContact?.id,
            sections: this.sections.toJSON(),
            attachments: this.attachments.toJSON()
        });
    },
    submit: function (callback) {
        this.beforeSave();

        new PJQ.ajax.Request({
            endpoint: `${this.endpoint()}/submit`,
            isAPIv2: true,
            data: this.toJSON()
        }).put().done((res) => {
            this.reset(res);
            callback(true);
        }).fail((xhr, err, result) => {
            callback(null, err);
        });
    },
    getItems: function () {
        return this.sections.reduce((items, section) => {
            return items.concat(section.items.models);
        }, []);
    },
    getStats: function () {
        let items = this.getItems(),
            itemsLen = items.length ?? 0;
        if (itemsLen > 0) {
            let stats = {
                totalItems: itemsLen,
                completeItems: 0
            };
            _.each(items, (item) => {
                if (item.get('choiceId') != null || item.get('response') != null) {
                    stats.completeItems++;
                }
            });
            return stats;
        }

        return this.get('stats');
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'inspections',
                    value: this.id
                },
                {
                    endpoint: 'email',
                }
            ]),
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done((res) => {
            callback(res);
        }).fail((xhr, err, result) => {
            callback(null, err);
        });
    },
});

// Inspection Type Model
PJQ.models.inspections.Type = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections'
            },
            {
                endpoint: 'types',
                value: this.id
            }
        ]);
    }
});

// Inspection Section Model
PJQ.models.inspections.Section = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        this.items = new PJQ.collections.inspections.Items(model.items);

        return model;
    }
});

// Inspection Item Model
PJQ.models.inspections.Item = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        if (model.responseTypeId == null) {
            model.responseTypeId = 0;
        }

        this.attachments = new PJQ.collections.inspections.Attachments(model.attachments);

        this.comments = new PJQ.collections.inspections.Comments(model.comments ?? [], {
            isAPIv2: true
        });

        return model;
    },
    isNA: function (responseTypes) {
        let rTypeId = this.get('responseTypeId');
        if (this.attributes.choiceId > 0 && responseTypes && rTypeId > 0) {
            if (responseTypes == null) {
                return false;
            }

            let responseType = responseTypes.get(rTypeId),
                choice = responseType.choices.get(this.attributes.choiceId);
            return choice == null ? false : choice.get('value') == null;
        }

        return this.get('choiceId') === -1;
    },
    getResponseSize() {
        let response = this.get('response');

        if (_.isDate(response)) {
            return _.size(response.toISOString());
        } else if (_.isString(response) || _.isArray(response) || _.isObject(response)) {
            return _.size(response);
        }
        return _.isNumber(response) ? 1 : 0;
    }
});

PJQ.models.inspections.ScheduleAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.inspections.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.inspections.Comment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections',
                value: this.get('inspectionId')
            },
            {
                endpoint: 'items',
                value: this.get('itemId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.inspections.ResponseType = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        this.choices = new PJQ.collections.inspections.ResponseTypeChoices(model.choices);

        return model;
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections'
            },
            {
                endpoint: 'responsetypes',
                value: this.id
            }
        ]);
    },
    getInputHtml: function () {
        let result = '<div class="btn-group wd-100 flex-wrap-wrap">';
        _.each(this.choices.models, (choice) => {
            let value = choice.get('value'),
                btnType;
            if (value === true) {
                btnType = 'btn-success';
            } else if (value === false) {
                btnType = 'btn-danger';
            } else if (value === null) {
                btnType = 'btn-light';
            } else {
                return;
            }

            result += `<button type="button" data-value="true" class="btn ${btnType} inactive">${choice.get('name')}</button>`;
        });
        result += '</div>';
        return result;
    },
    beforeSave: function () {
        this.set({
            choices: this.choices.toJSON()
        });
    }
});

// Custom Response Model
PJQ.models.inspections.ResponseTypeChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

// User Settings Model
PJQ.models.inspections.UserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

// Settings Model
PJQ.models.inspections.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'inspections'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'inspections'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
    }
});


// Collections
PJQ.collections.inspections.Schedules = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Schedule,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'inspections'
            },
            {
                endpoint: 'schedules'
            }]);
    }
});

PJQ.collections.inspections.ScheduleAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.ScheduleAttachment
});

// Templates Collection
PJQ.collections.inspections.Templates = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Template,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push({
                endpoint: 'inspections'
            },
            {
                endpoint: 'templates'
            });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

// Inspections Collection
PJQ.collections.inspections.Inspections = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Inspection,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'inspections'
            }
        ]);
    }
});

// Inspection Types Collection
PJQ.collections.inspections.Types = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Type,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push({
                endpoint: 'inspections'
            },
            {
                endpoint: 'types'
            });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

// Inspection Sections Collection
PJQ.collections.inspections.Sections = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Section
});

PJQ.collections.inspections.Items = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Item
});

PJQ.collections.inspections.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections',
                value: this.options.inspectionId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.inspections.Comments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.Comment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'inspections',
                value: this.options.inspectionId
            },
            {
                endpoint: 'items',
                value: this.options.itemId
            },
            {
                endpoint: 'comments'
            }
        ]);
    }
});

// Custom Response Types Collection
PJQ.collections.inspections.ResponseTypes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.ResponseType,
    endpoint: function () {
        let arr = [];
        if (this.options.project) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push({
                endpoint: 'inspections'
            },
            {
                endpoint: 'responsetypes'
            });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

// Custom Response Collection
PJQ.collections.inspections.ResponseTypeChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.inspections.ResponseTypeChoice
});
PJQ.views.inspections.ReponseTypeEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-edit-inspection-response-type'),
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete',
        'click .btn-add-choice': 'addChoice',
        'click .btn-delete-choice': 'deleteChoiceClicked',
        'click .choice-value-group>button': 'choiceValueChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model == null) {
            this.model = new PJQ.models.inspections.ResponseType({});
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            await this.model.fetch();
        }

        this.listenTo(this.model.choices, "update change", this.renderPreview);

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderPreview();

        this.binder = new PJQ.Binder(this.$('.response-type-data'), this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: true,
            setDefaultValues: true
        });

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.choices-data'),
            isHideSearch: true,
            data: _.filter(this.model.choices.models, (choice) => {
                return !choice.get('delete');
            }),
            rowId: "cid",
            order: [0, 'asc'],
            paging: false,
            // sortableOptions: {
            //     handle: '.sort-handle',
            //     dataAttribute: 'sortOrder'
            // },
            afterDataTableRender: () => {
                this.choicesBinder = new PJQ.Binder(this.$('.choices-data'), this.model.choices, {
                    watchElements: [
                        'input',
                        'textarea'
                    ],
                    modelSelectorAttribute: 'id',
                    idAttribute: 'cid',
                    canEdit: true,
                    delegate: true,
                    setDefaultValues: true
                });
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteChoice(row.data());
                        }
                    }
                ]
            },
            columns: [
                // {
                //     // "data": "",
                //     "title": '',
                //     "orderable": false,
                //     "width": "40px",
                //     "render": (data, type, row) => {
                //         return '<i class="fas fa-sort sort-handle mr-2"></i>';
                //     }
                // },
                {
                    "data": "attributes.name",
                    "title": `Name ${PJQ.constants.markup.requiredAst}`,
                    "render": (data, type, row) => {
                        return `<input type="text" class="form-control" maxlength="100" value="${data ?? ''}" data-p-bind="name">`;
                    }
                },
                {
                    "data": "attributes.value",
                    "title": `Value ${PJQ.constants.markup.requiredAst}`,
                    "width": "350px",
                    "render": (data, type, row) => {
                        return `
                            <div class="d-flex">
                                <div class="btn-group flex-fill choice-value-group" data-id="${row.cid}">
                                    <button type="button" data-value="true" class="btn btn-success ht-30p ${row.get('value') !== true ? 'inactive' : ''}"></button>
                                    <button type="button" data-value="false" class="btn btn-danger ht-30p ${row.get('value') !== false ? 'inactive' : ''}"></button>
                                    <button type="button" data-value="null" class="btn btn-light ht-30p ${row.get('value') != null ? 'inactive' : ''}"></button>
                                </div>
                            </div>
                        `;
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": () => {
                        return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-choice wd-30p"><i class="fal fa-trash-alt"></i></button></div>'
                    },
                }
            ]
        });
    },
    renderPreview: function () {
        let $preview = this.$('.response-type-preview');
        $preview.html(this.model.getInputHtml());
    },
    addChoice: function () {
        let choice = new PJQ.models.inspections.ResponseTypeChoice({
            name: '',
            value: null
        });
        this.model.choices.add(choice);
        this.dataTable.addRow(choice);
    },
    deleteChoiceClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChoice(row.data());
    },
    deleteChoice: function (choice) {
        if (choice.id > 0) {
            choice.set('delete', true);
        } else {
            this.model.choices.remove(choice);
        }
        this.dataTable.removeRow(choice.cid);
    },
    choiceValueChanged: function (e) {
        let $button = $(e.currentTarget),
            value = $button.data('value'),
            id = $button.closest('.choice-value-group').data('id'),
            choice = this.model.choices.get(id);

        if (choice != null) {
            choice.set('value', value);
            this.dataTable.refreshRow(choice.cid);
        }
    },
    validate: function () {
        if (this.errorAlert != null) {
            this.errorAlert.remove();
        }

        let binderRes = this.binder.validate(),
            isValid = binderRes.isValid,
            errors = binderRes.errors;

        if (_.size(errors) > 0) {
            this.errorAlert = new PJQ.Alert(this.$('.error-outer'), {
                type: 'danger',
                text: errors.join('<br>')
            });
        }

        return isValid;
    },
    save: function () {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Response Type saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Response Type?",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        PJQ.notifications.notify.successNotify({
                            message: 'Inspection Response Type deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }
                });
            }
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: () => {
                    this.save();
                    this.removeModal();
                },
                onDontSave: () => {
                    this.model.restore();
                    this.removeModal();
                }
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.inspections.ResponseTypesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspection-response-types-list')
    },
    events: {
        'click .btn-add-response-type': 'addResponseType',
        'click .btn-view-response-type': 'viewResponseTypeClicked',
        'click .btn-delete-response-type': 'deleteResponseTypeClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = await PJQ.app.session.fetchInspectionResponseTypes();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.response-types-table'),
            isHideSearch: true,
            data: this.collection?.models ?? [],
            rowId: "cid",
            order: [0, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'Click "Add Response Type" to create a new Response Type'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewResponseType(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.viewResponseType(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteResponseType(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return data;
                        }

                        return `<a href="javascript:void(0);" class="text-primary btn-view-response-type">${data}</a>`;
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": _.bind(function () {
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info btn-view-response-type mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-response-type"><i class="fal fa-trash-alt"></i></button></button></div>'
                    }, this)
                }
            ]
        });
    },
    viewResponseTypeClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewResponseType(row.data());
    },
    viewResponseType: function (responseType) {
        new PJQ.views.inspections.ReponseTypeEditModal({
            model: responseType,
            onSave: (responseType) => {
                let isNew = this.collection.findWhere({id: responseType.id}) == null;

                this.collection.add(responseType);

                if (isNew) {
                    this.dataTable.addRow(responseType);
                }
            }
        });
    },
    addResponseType: function () {
        this.viewResponseType();
    },
    deleteResponseTypeClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteResponseType(row.data());
    },
    deleteResponseType: function (responseType) {
        let row = this.dataTable.getRow(responseType.cid);

        if (row != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Response Type",
                body: "Are you sure you want to delete this response type?",
                onDelete: _.bind(function () {
                    responseType.destroy({
                        success: _.bind(function () {
                            this.dataTable.removeRow(row);
                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete(responseType);
                            }
                        }, this)
                    });
                }, this)
            });
        }
    }
});
PJQ.views.inspections.ScheduleEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-edit-inspection-schedule'),
        width: '95%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.options.project = this.options.project ?? PJQ.app.session.project;
        this.isFetched = false;
        this.preferences = this.options.project.preferences;

        if (this.model == null) {
            this.model = new PJQ.models.inspections.Schedule({
                projectId: this.options.project.id,
                templateId: this.options.templateId,
                createDaysBeforeDue: 0,
                daysOfWeek: 127
            });
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            await this.model.fetch();
        }

        this.templates = await this.options.project.fetchInspectionTemplates();

        this.inspectionTypes = await this.options.project.fetchInspectionTypes();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;

        this.options.isAdmin = this.options.project.hasPermission('inspections.isAdmin');
        this.options.canEdit = this.options.isAdmin;
    },
    renderData: function () {
        return {
            model: this.model,
            preferences: this.preferences,
            canEdit: this.options.canEdit,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        let disabledDays = this.getDisabledDays(),
            minDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), 1),
            startDate = PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false),
            endDate = PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false),
            templates = _.map(this.templates.models, (template) => {
                return {
                    id: template.get('id'),
                    name: template.get('name')
                }
            });

        if (_.size(templates) === 0) {
            templates.push({
                id: null,
                name: 'No Templates Available',
                disabled: true
            });
        }

        this.binder = new PJQ.Binder(this.$el, this.model, {
            project: this.options.project,
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: this.options.canEdit,
            setDefaultValues: true,
            inputs: {
                templateId: {
                    selectPicker: {
                        choices: templates,
                    },
                },
                frequency: {
                    afterChange: () => {
                        this.render();
                    },
                    selectPicker: {
                        choices: _.map(PJQ.constants.inspections.frequencyTypes, (freqType) => {
                            return {
                                id: freqType,
                                name: PJQ.constants.inspections.frequencyNames[freqType]
                            }
                        }),
                        canEdit: this.model.isNew() && this.options.canEdit
                    }
                },
                startDate: {
                    datePicker: {
                        disabledDays: disabledDays,
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: startDate,
                            minDate: startDate < minDate ? startDate : minDate
                        }
                    },
                    validate: (sDate, obj) => {
                        let res = {isValid: true, errors: []};
                        if (sDate == null) {
                            res.isValid = false;
                            res.errors.push("Start date is required");
                            return res;
                        }

                        let startDate = new Date(sDate),
                            createBeforeDays = obj.get('createDaysBeforeDue');
                        if (createBeforeDays > 0) {
                            startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(startDate, -createBeforeDays);
                        }

                        let hasDayChange = this.model.isNew(),
                            initCreateBeforeDays = this.model.get('createDaysBeforeDue')
                        if (!this.model.isNew()) {
                            let initStartDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(this.model.initAttributes.startDate), -(initCreateBeforeDays ?? 0));
                            hasDayChange = initStartDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(startDate, initStartDate) !== 0;
                        }

                        let startInDays = PJQ.helpers.dateHelpers.getDateDaysDiff(startDate, new Date(), false, true);
                        if (hasDayChange && startInDays <= 0) {
                            res.isValid = false;
                            res.errors.push("The First Inspection Date (minus Create Before Due days) must be a future date.");
                            return res;
                        }

                        return res;
                    }
                },
                endDate: {
                    datePicker: {
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: endDate,
                            minDate: endDate < minDate ? endDate : minDate
                        }
                    },
                    validate: (eDate) => {
                        if (this.model.get('frequency') === PJQ.constants.inspections.frequencyTypes.ONCE) {
                            return true;
                        }

                        let res = {isValid: true, errors: []};
                        if (eDate == null) {
                            res.isValid = false;
                            res.errors.push("End date is required");
                            return res;
                        }

                        let endDate = new Date(eDate),
                            startDate = this.model.get('startDate');
                        if (startDate != null) {
                            let daysDiff = PJQ.helpers.dateHelpers.getDateDaysDiff(endDate, new Date(startDate), false, true);
                            if (daysDiff <= 0) {
                                res.isValid = false;
                                res.errors.push("End date must be after start date");
                            }
                            return res;
                        }

                        return res;
                    }
                },
                groupId: {
                    groupPicker: {}
                },
                locationId: {
                    locationPicker: {}
                },
                assignedTo: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: false
                    }
                },
                distributeTo: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: false
                    }
                },
                pointOfContact: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        isSingleChoice: true
                    }
                },
                attachments: {
                    fileUploader: {
                        useApiV2: true,
                        canView: true,
                    }
                }
            }
        });

        let daysOfWeek = this.model.get('daysOfWeek');
        if (this.model.get('frequency') === PJQ.constants.inspections.frequencyTypes.DAILY) {
            this.workDayPicker = new PJQ.inputs.DayPicker({
                el: this.$('.work-days-outer'),
                defaultValue: daysOfWeek,
                onChange: (value) => {
                    this.model.set('daysOfWeek', value);

                    let disabledDays = this.getDisabledDays(),
                        startPicker = this.binder.getInput('startDate');
                    if (startPicker != null) {
                        startPicker.setDisabledDays(disabledDays);

                        let startDate = PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false);
                        if (startDate != null && -1 !== disabledDays.indexOf(startDate.getDay())) {
                            this.model.set('startDate', null);
                            startPicker.setValue(null);
                        }
                    }

                    let endPicker = this.binder.getInput('endDate');
                    if (endPicker != null) {
                        endPicker.setDisabledDays(disabledDays);

                        let endDate = PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false);
                        if (endDate != null && -1 !== disabledDays.indexOf(endDate.getDay())) {
                            this.model.set('endDate', null);
                            endPicker.setValue(null);
                        }
                    }
                }
            });
        }
    },
    getDisabledDays: function () {
        let disabledDays = [],
            daysOfWeek = this.model.get('daysOfWeek');
        _.each(PJQ.constants.date.WEEKDAYNAMES, (day, i) => {
            if ((daysOfWeek & day.bit) !== day.bit) {
                disabledDays.push(i);
            }
        });
        return disabledDays;
    },
    validate: function () {
        if (this.errorAlert != null) {
            this.errorAlert.remove();
        }

        let binderRes = this.binder.validate(),
            isValid = binderRes.isValid,
            errors = binderRes.errors,
            $daysOfWeekLabel = this.$('.work-days-outer').siblings('label');
        if (this.model.get('frequency') !== PJQ.constants.inspections.frequencyTypes.ONCE && this.model.get('daysOfWeek') === 0) {
            errors.push('At least one day of the week must be selected');
            isValid = false;
            $daysOfWeekLabel.addClass('text-danger');
        } else {
            $daysOfWeekLabel.removeClass('text-danger');
        }

        if (_.size(errors) > 0) {
            this.errorAlert = new PJQ.Alert(this.$('.error-outer'), {
                type: 'danger',
                text: errors.join('<br>')
            });
        }

        return isValid;
    },
    save: function () {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Inspection Schedule saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Inspection Schedule?",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        PJQ.notifications.notify.successNotify({
                            message: 'Inspection Schedule deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }
                });
            }
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: () => {
                    this.save();
                    this.removeModal();
                },
                onDontSave: () => {
                    this.model.restore();
                    this.removeModal();
                }
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.inspections.ManageSchedulesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-manage-inspection-schedules'),
        maxWidth: '800px',
        isShowCloseButton: true
    },
    events: {},
    beforeModalCreated: async function () {

    },
    beforeRender: function () {

    },
    renderData: function () {
        return {};
    },
    afterRender: function () {
        this.hadChange = false;
        new PJQ.views.inspections.ScheduleList({
            el: this.$('.inspection-schedules'),
            project: this.options.project,
            onChange: () => {
                this.hadChange = true;
            }
        });
    },
    onClose: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.hadChange);
        }
    }
});


PJQ.views.inspections.ScheduleList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspection-schedules-list')
    },
    events: {
        'click .btn-add-schedule': 'addSchedule',
        'click .btn-view-schedule': 'viewScheduleClicked',
        'click .btn-delete-schedule': 'deleteScheduleClicked',
        'click .btn-export': 'export'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ?? PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.inspections.Schedules(null, {
                projectId: this.options.project.id
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.templates = await this.options.project.fetchInspectionTemplates();
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.schedules-table'),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [2, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'Click "Add Schedule" to create a new Inspection Schedule'
            },
            onRowDoubleClick: (row) => {
                this.viewSchedule(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.viewSchedule(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteSchedule(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return data;
                        }

                        return `<a href="javascript:void(0);" class="text-primary btn-view-schedule">${data}</a>`;
                    }
                },
                {
                    "data": "attributes.frequency",
                    "title": "Frequency",
                    "width": "80px",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return data;
                        }

                        return PJQ.constants.inspections.frequencyNames[data] ?? '';
                    }
                },
                {
                    "data": "attributes.startDate",
                    "title": "Dates",
                    "width": "175px",
                    "render": (data, type, row) => {
                        let start = new Date(row.get('startDate'));
                        if (type === 'sort') {
                            return start.valueOf();
                        }

                        let end = new Date(row.get('endDate')),
                            daysSinceStart = PJQ.helpers.dateHelpers.getDateDaysDiff(new Date(), start),
                            daysToEnd = PJQ.helpers.dateHelpers.getDateDaysDiff(end, new Date()),
                            startStr = PJQ.helpers.dateHelpers.getDateString(start, PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                            res = '';
                        if (row.get('frequency') === PJQ.constants.inspections.frequencyTypes.ONCE) {
                            res = startStr;
                        } else {
                            res = startStr + ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }

                        let classes = '';
                        if (daysSinceStart >= 0 && daysToEnd >= 0) {
                            // currently active date span
                            classes = 'font-weight-bold text-success';
                        } else if (daysToEnd < 0) {
                            // date span has ended
                            classes = 'text-muted';
                        }

                        return (`<span class="${classes}">${res}</span>`)
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "width": "100px",
                    "orderable": false,
                    "searchable": false,
                    "render": () => {
                        return '<div style="width:80px;" class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-view-schedule wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-schedule wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
                    }
                }
            ]
        });
    },
    viewScheduleClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewSchedule(row.data());
    },
    viewSchedule: function (schedule) {
        let isNew = schedule?.isNew() ?? true;
        new PJQ.views.inspections.ScheduleEditModal({
            model: schedule,
            onSave: (schedule) => {
                this.hadChange = true;

                this.collection.add(schedule);

                if (isNew) {
                    this.dataTable.addRow(schedule);
                } else {
                    let row = this.dataTable.getRow(schedule.cid);
                    if (row) {
                        this.dataTable.refreshRow(row);
                    }
                }

                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(schedule);
                }
            },
            onDelete: (schedule) => {
                this.dataTable.removeRow(schedule);

                if (typeof this.options.onChange === 'function') {
                    this.options.onDelete(schedule);
                }
            }
        });
    },
    addSchedule: function () {
        this.viewSchedule(null);
    },
    deleteScheduleClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteSchedule(row.data());
    },
    deleteSchedule: function (schedule) {
        let row = this.dataTable.getRow(schedule.cid);
        if (row == null) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: "Delete Inspection Schedule",
            body: "Are you sure you want to delete this Inspection Schedule?",
            onDelete: () => {
                schedule.destroy({
                    success: () => {
                        this.dataTable.removeRow(row);
                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(schedule);
                        }
                    }
                });
            }
        });
    }
});
PJQ.views.inspections.SettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-inspection-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.view.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.view.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        // let defaultFilter = {};
        // defaultFilter[PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER] = this.userSettings.get('defaultStatusFilter');


        // this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
        //     el: this.$('.select-filter-default'),
        //     isIntChoices: true,
        //     isMultiple: true,
        //     isGrouped: true,
        //     mustSelectValuePerOptGroup: true,
        //     defaultValue: defaultFilter,
        //     onHide: _.bind(function () {
        //         this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER];
        //     }, this)
        // });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.inspections.views.INSPECTIONS);
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        this.rowsPerPage.setValue(this.currentView.rowsPerPage);

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});
PJQ.views.inspections.InspectionTemplateEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-edit-inspection-template'),
        width: '95%',
        maxWidth: 1200,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.preferences = this.options.project?.preferences ?? PJQ.app.session.preferences;

        if (this.model == null) {
            this.model = new PJQ.models.inspections.Template({
                projectId: this.options.project?.id
            });
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            await this.model.fetch();
        }

        this.inspectionTypes = await PJQ.app.session.fetchInspectionTypes();

        this.responseTypes = await PJQ.app.session.fetchInspectionResponseTypes();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;

        this.options.canEdit = this.options.canEdit ?? true;
    },
    renderData: function () {
        return {
            model: this.model,
            preferences: this.preferences,
            canEdit: this.options.canEdit,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: this.options.canEdit,
            setDefaultValues: true,
            inputs: {
                typeId: {
                    selectPicker: {
                        choices: _.map(this.inspectionTypes.models, (type) => {
                            return {
                                id: type.id,
                                name: type.get('name')
                            };
                        })
                    }
                },
                groupId: {
                    groupPicker: {}
                },
                defaultResponseTypeId: {
                    selectPicker: {
                        defaultValue: this.model.get('defaultResponseTypeId') ?? PJQ.constants.inspections.responseTypes.PASSFAIL,
                        choices: () => {
                            let types = _.map(_.filter(PJQ.constants.inspections.responseTypes, (responseType) => {
                                return responseType !== PJQ.constants.inspections.responseTypes.CUSTOM;
                            }), function (responseType) {
                                return {
                                    id: responseType,
                                    name: PJQ.constants.inspections.responseTypeNames[responseType]
                                }
                            });

                            types.push(..._.map(this.responseTypes?.models, (responseType) => {
                                return {
                                    id: -responseType.id,
                                    name: responseType.get('name')
                                }
                            }));

                            return types;
                        }
                    }
                },
                attachments: {
                    fileUploader: {
                        useApiV2: true,
                        canView: true,
                    }
                }
            }
        });

        this.renderItems();
    },
    renderItems: function () {
        this.itemsTable = new PJQ.views.inspections.InspectionItemsDatatable({
            el: this.$('.template-items'),
            rowId: "cid",
            responseTypes: this.responseTypes,
            model: this.model,
            data: _.filter(this.model.sections?.models ?? [], (section) => !section.get('delete')),
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        onClick: (row) => {

                        },
                        isDanger: true
                    }
                ]
            },
            onSectionAdd: (section) => {
                this.model.sections.add(section);
                this.model.isDirty = true;
            },
            onSectionDelete: (section) => {
                this.model.isDirty = true;
            },
            onItemAdd: (item) => {
                this.model.isDirty = true;
            },
            onItemDelete: (item) => {
                this.model.isDirty = true;
            }
        });
    },
    validate: function () {
        let binderRes = this.binder.validate();
        if (_.size(binderRes.errors) > 0) {
            this.errorAlert = new PJQ.Alert(this.$('.error-outer'), {
                type: 'danger',
                text: binderRes.errors.join('<br>')
            });
        }
        return binderRes.isValid;
    },
    save: function () {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Inspection Template saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Inspection Template?",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        PJQ.notifications.notify.successNotify({
                            message: 'Inspection Template deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }
                });
            }
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: () => {
                    this.save();
                    this.removeModal();
                },
                onDontSave: () => {
                    this.model.restore();
                    this.removeModal();
                }
            });
        } else {
            this.model.restore();
            this.removeModal();
        }
    }
});

PJQ.views.inspections.BulkAddInspectionItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-bulk-add-inspection-items'),
        // width: '95%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'keyup .input-items-text': 'itemsTextChanged',
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.responseTypes = await PJQ.app.session.fetchInspectionResponseTypes();
    },
    renderData: function () {
        return {}
    },
    afterRender: function () {
        if (this.responseType == null) {
            this.responseType = this.options.responseType ?? PJQ.constants.inspections.responseTypes.PASSFAIL;
        }

        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-response-type'),
            onChange: (value) => {
                this.responseType = value;
            },
            choices: () => {
                let types = _.map(_.filter(PJQ.constants.inspections.responseTypes, (responseType) => {
                    return responseType !== PJQ.constants.inspections.responseTypes.CUSTOM;
                }), function (responseType) {
                    return {
                        id: responseType,
                        name: PJQ.constants.inspections.responseTypeNames[responseType]
                    }
                });

                types.push(..._.map(this.options.responseTypes?.models, (responseType) => {
                    return {
                        id: -responseType.id,
                        name: responseType.get('name')
                    }
                }));

                return types;
            },
            defaultValue: this.responseType,
            noneSelectedText: 'No Filters'
        });
    },
    itemsTextChanged: function () {
        let text = this.$('.input-items-text').val(),
            lines = text.split('\n'),
            maxSort = 0,
            sectionSort = this.options.section.get('sortOrder'),
            previewText = '';
        _.each(this.options.section.items.models, (section) => {
            let tSort = section.get('sortOrder');
            if (tSort > maxSort) {
                maxSort = tSort;
            }
        });

        this.items = [];
        _.each(lines, (line) => {
            if (line.trim() === '') {
                return;
            }

            maxSort += 1;
            this.items.push({
                sortOrder: maxSort,
                title: line
            });

            previewText += `${sectionSort}.${maxSort} ${line}` + '\n';
        });

        this.$('.items-preview').text(previewText);
    },
    save: function () {
        this.options.section.items.add(_.map(this.items, (item) => {
            return new PJQ.models.inspections.Item({
                title: item.title,
                sortOrder: item.sortOrder,
                responseType: this.responseType ?? PJQ.constants.inspections.responseTypes.PASSFAIL
            });
        }));
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.options.section);
        }
        this.removeModal();
    }
});
PJQ.views.inspections.InspectionTemplatesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspection-templates-list')
    },
    events: {
        'click .btn-add-template': 'addTemplate',
        'click .btn-view-template': 'viewTemplateClicked',
        'click .btn-delete-template': 'deleteTemplateClicked',
        'click .btn-export': 'export'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        if (this.collection == null) {
            this.collection = new PJQ.collections.inspections.Templates();
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.inspectionTypes = await PJQ.app.session.fetchInspectionTypes();

        if (this.options.project != null) {
            this.groups = await this.options.project.fetchGroups();
        } else {
            this.groups = await PJQ.app.session.fetchUserGroups();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.inspection-templates-table'),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'Click "Add Template" to create a new Template'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewTemplate(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.viewTemplate(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteTemplate(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return data;
                        }

                        return `<a href="javascript:void(0);" class="text-primary btn-view-template">${data}</a>`;
                    }
                },
                {
                    "data": "attributes.typeId",
                    "title": "Type",
                    "render": _.bind(function (data, type, row) {
                        let inspectionType = this.inspectionTypes.get(data);

                        return inspectionType?.get('name') ?? '';
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": _.bind(function () {
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info btn-view-template mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-template"><i class="fal fa-trash-alt"></i></button></button></div>'
                    }, this)
                }
            ]
        });
    },
    viewTemplateClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewTemplate(row.data());
    },
    viewTemplate: function (inspection) {
        new PJQ.views.inspections.InspectionTemplateEditModal({
            model: inspection,
            onSave: (inspection) => {
                let isNew = this.collection.findWhere({id: inspection.id}) == null;

                this.collection.add(inspection);

                if (isNew) {
                    this.dataTable.addRow(inspection);
                }
            }
        });
    },
    addTemplate: function () {
        this.viewTemplate();
    },
    deleteTemplateClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteTemplate(row.data());
    },
    deleteTemplate: function (inspection) {
        let row = this.dataTable.getRow(inspection.cid);

        if (row != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Inspection Template",
                body: "Are you sure you want to delete this template",
                onDelete: _.bind(function () {
                    inspection.destroy({
                        success: _.bind(function () {
                            this.dataTable.removeRow(row);
                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete(inspection);
                            }
                        }, this)
                    });
                }, this)
            });
        }
    }
});
PJQ.views.inspections.TypeEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'modal-edit-inspection-type'),
        width: '95%',
        maxWidth: 400,
        model: null,
        isShowCloseButton: true,
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model == null) {
            this.model = new PJQ.models.inspections.Type({
                projectId: this.options.project?.id,
            });
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
            ],
            setDefaultValues: true
        });
    },
    validate: function () {
        if (this.errorAlert != null) {
            this.errorAlert.remove();
        }

        let res = this.binder.validate();
        if (_.size(res.errors) > 0) {
            this.errorAlert = new PJQ.Alert(this.$('.error-outer'), {
                type: 'danger',
                text: res.errors.join('<br>')
            });
        }
        return res.isValid;
    },
    save: function () {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Inspection Type saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Inspection Type?",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        PJQ.notifications.notify.successNotify({
                            message: 'Inspection Type deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }
                });
            }
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: () => {
                    this.save();
                    this.removeModal();
                },
                onDontSave: () => {
                    this.model.restore();
                    this.removeModal();
                }
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.inspections.TypesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INSPECTIONS, 'inspection-types-list')
    },
    events: {
        'click .btn-add-type': 'addType',
        'click .btn-view-type': 'viewTypeClicked',
        'click .btn-delete-type': 'deleteTypeClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = await PJQ.app.session.fetchInspectionTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.types-table'),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'Click "Add Type" to create a new Inspection Type'
            },
            onRowDoubleClick: (row) => {
                this.viewType(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.viewType(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteType(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return data;
                        }

                        return `<a href="javascript:void(0);" class="text-primary btn-view-type">${data}</a>`;
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "width": "100px",
                    "orderable": false,
                    "searchable": false,
                    "render": () => {
                        return '<div style="width:80px;" class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-view-type wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-type wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
                    },
                    "width": "80px"
                }
            ]
        });
    },
    viewTypeClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewType(row.data());
    },
    viewType: function (type) {
        let isNew = type?.isNew() ?? true;
        new PJQ.views.inspections.TypeEditModal({
            model: type,
            onSave: (type) => {
                this.collection.add(type);

                if (isNew) {
                    this.dataTable.addRow(type);
                }

                this.dataTable.refresh();
            },
            onDelete: (type) => {
                this.dataTable.removeRow(type);
            }
        });
    },
    addType: function () {
        this.viewType(null);
    },
    deleteTypeClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteType(row.data());
    },
    deleteType: function (type) {
        let row = this.dataTable.getRow(type.cid);
        if (row == null) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: "Delete Inspection Type",
            body: "Are you sure you want to delete this Inspection Type?",
            onDelete: () => {
                type.destroy({
                    success: () => {
                        this.dataTable.removeRow(row);
                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(type);
                        }
                    }
                });
            }
        });
    }
});